
import NetworkImage from './NetworkImage.vue';

export default {
    name: 'Logo',
    components: { NetworkImage },

    props: {
        link: String,
        profile: Object,
        css: String,
    },
};
